
import { defineComponent, PropType, onUpdated, ref, computed, onMounted } from 'vue'
import { View } from '@/models/view'

export default defineComponent({
    name: 'NavigationDropDownTab',
    props: {
        values: {
            type: Object as PropType<View[]>,
            required: true
        },
        parent: {
            type: Object
        },
        active: {
            type: String,
            required: true
        },
        buttonList: {
            type: Array,
            required: true
        },
    },
    emits: ['click'],
    setup (props, { emit }) {
    const options = props.values.map(v => ({label: v.name, value: v}))
    const buttonViews = ref<View[]>([])

    const activeView = computed({
        get: () => props.values.find(view => view.name === props.active),
        set: (value) => {
        emit('click', value)
        }
    })

    function setButtonViews () {
        if (props.buttonList) for (let i = 0; i < 2; i++) {
            buttonViews.value.push(options.filter(option => option.label == props.buttonList[i])[0].value)
            // console.log('buttonViews', buttonViews)
        }
    }

    onMounted(() => {
        setButtonViews()
    })

    return {
        activeView,
        options,
        buttonViews,
        contentWidth: computed(() => {
        return options.map(n => n.label).reduce((s,n) => s.length > n.length ? s : n,'').length * 12
        })
    }
    }
})
